/**
 * Single source of truth for TanStack Query keys.
 *
 * Extracted from the individual `hooks/queries/*` modules (A8) so that pure,
 * dependency-free code — notably `utils/notificationInvalidation.ts` — can name
 * the same caches without importing the hooks (and, through them, axios and the
 * whole API layer).
 *
 * Convention: a key is an array whose FIRST element is the cache family. Passing
 * only that first element to `invalidateQueries` matches every variant by
 * prefix, which is how the parameterised feeds (`discover-track` per circle,
 * `my-recommendations` per search term) are invalidated wholesale.
 */

/** The user's circles. */
export const MY_GROUPS_KEY = ['my-groups'] as const;

/** Members of one circle. */
export const groupMembersKey = (groupId: number) => ['group-members', groupId] as const;

/** Pending join requests of one circle (admin view). */
export const groupRequestsKey = (groupId: number) => ['group-requests', groupId] as const;

/** A6 — per-circle notification preferences. */
export const groupNotifPrefsKey = (groupId: number) => ['group-notif-prefs', groupId] as const;

/**
 * Discover feed. The full key is `['discover-track', selectedGroupId,
 * includePublic]`; this prefix matches every circle/visibility combination.
 */
export const DISCOVER_TRACK_KEY = ['discover-track'] as const;

/**
 * "My Recos" list + impact totals. The full key is
 * `['my-recommendations', searchTerm]`; this prefix matches every search term.
 */
export const MY_RECOMMENDATIONS_KEY = ['my-recommendations'] as const;
